<template>
  <div class="reg-temp-main-heading">
    <header class="reg-temp-header justify-content-between">
      <div class="left">
        <a href="" class="ham-menu" @click.prevent="va_setHamMenu(true)"><i class="fa fa-bars" aria-hidden="true"></i></a>  
        <div class="page-breadcrumb">
          Home / {{ navText }}

        </div>
      </div>
      <!-- <div class="right">
          <a href="">
            <i class="fa fa-bell" aria-hidden="true"></i>
          </a>
          <a href="">
            <i class="fa fa-comments" aria-hidden="true"></i>
          </a>
      </div> -->
    </header>
  </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  data() {
    return {
      navText: '',
    }
  },
   computed: {
    ...mapGetters({
      vg_loggedInUserName: "auth/username",
      vg_hamMenuActive: "menu/active",
    }),
  },

  watch:{
     '$route' (to, from) {
       this.navText = to.meta.navText;
     }
  },
  methods: {
    ...mapActions({
      va_setHamMenu: 'menu/setMenu',
    })
  },
  mounted() {
     this.navText = this.$route.meta.navText;
  },

};
</script>